import { useCallback, useState } from "react";
import { Table, Button, Space, Modal, notification, Spin, Input } from "antd";
import { useRequest } from "../../../hooks";
import { getOrgs, deleteOrg } from "../../../api/organization";
import UsetUpsert from "./Upsert";
import { textRender } from "../../../utils";
import IfNotObserver from "../../common/IfNotObserver";

export default function Org() {
    const [showModal, setShowModal] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [edittingRecord, setEdittingRecord] = useState<Orgnization>();
    const [keywords, setKeywords] = useState('');
    const [searchParams, setSearchParams] = useState<Partial<SearchOrgParams>>({ organizationName: keywords });
    const [pagination, setPagination] = useState({
        pageNum: 1,
        pageSize: 10,
    });
    const fetchData = useCallback(() => {
        return getOrgs({
            ...pagination,
            ...searchParams
        })
    }, [pagination, searchParams]);
    const { data, loading } = useRequest(fetchData);
    return (
        <Spin spinning={deleting}>
            <Space>
                <Input.Search onSearch={() => {
                    setSearchParams({
                        ...searchParams,
                        organizationName: keywords,
                        pageNum: 1
                    })
                }} onChange={e => {
                    setKeywords(e.target.value)
                }} placeholder="请输入展馆名称" />
                <IfNotObserver>
                    <Button type='primary' onClick={() => setShowModal(true)}>创建展馆</Button>
                </IfNotObserver>

            </Space>
            <br /> <br />
            <Table
                pagination={{
                    pageSize: pagination.pageSize,
                    current: pagination.pageNum,
                    total: data?.total,
                    onChange: (pageNum, pageSize) => {
                        setPagination({
                            ...pagination,
                            pageSize,
                            pageNum
                        })
                    }
                }}
                columns={[
                    {
                        dataIndex: 'organizationId',
                        title: 'ID',
                    },
                    {
                        dataIndex: 'name',
                        title: '名称',
                    },
                    {
                        dataIndex: 'province',
                        title: '所在省份',
                    },
                    {
                        dataIndex: 'city',
                        title: '所在城市',
                    },
                    {
                        dataIndex: 'description',
                        title: '备注信息',
                        render: textRender,
                    },
                    {
                        dataIndex: 'actions',
                        title: '操作',
                        render: (_, row) => {
                            return (
                                <IfNotObserver>

                                    <Space size="middle">
                                        <a onClick={e => {
                                            e.preventDefault()
                                            setEdittingRecord(row)
                                            setShowModal(true)
                                        }}>编辑</a>
                                        <a onClick={e => {
                                            e.preventDefault()
                                            Modal.confirm({
                                                title: '确定删除? 此操作不可撤销',
                                                onOk: () => {
                                                    setDeleting(true)
                                                    deleteOrg(row.organizationId)
                                                        .then(() => {
                                                            notification.success({ message: '删除成功' })
                                                            setPagination({
                                                                ...pagination,
                                                                pageNum: 1
                                                            })
                                                        }).catch(() => {
                                                            notification.error({ message: '删除失败, 请重试' })
                                                        })
                                                        .finally(() => setDeleting(false))
                                                }
                                            })
                                        }}>删除</a>
                                    </Space>
                                </IfNotObserver>
                            )
                        }
                    }
                ]}
                loading={loading}
                dataSource={data?.data}
            />
            <Modal destroyOnClose title='创建/编辑展馆' open={showModal} footer={null} onCancel={() => { setShowModal(false) }}>
                <br />
                <UsetUpsert initialValues={edittingRecord} onComplete={() => {
                    setPagination({
                        ...pagination,
                        pageNum: 1
                    });
                    setEdittingRecord(undefined)
                    setShowModal(false)
                }} />
            </Modal>
        </Spin>
    )
}